var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.568,
    height: 25.88,
    viewBox: "0 0 25.568 25.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(-95.361 -6125.156)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 9.723,
    cy: 9.723,
    r: 9.723,
    transform: "translate(96.07 6125.865)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x2: 7.78,
    y2: 7.78,
    transform: "translate(112.648 6142.755)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1.417
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/iconSearch.63ff357f2e3bee2db333808b4f5c48fb.svg";
export { ForwardRef as ReactComponent };